import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { FlueStatusSearchParams } from "./flue-status";

export type FlueViewParams = FlueStatusSearchParams & {
  mainTab?: string;
  period?: string;
};

const defaultValues: FlueViewParams = {
  search: "",
  postalCode: "",
  mainTab: "overview",
  period: "",
};

export const Route = createFileRoute("/flue-status/$id")({
  validateSearch: (params: Record<string, unknown>): FlueViewParams => {
    // validate and parse the search params into a typed state
    return {
      search: (params["search"] as string) ?? "",
      postalCode: params["postalCode"]?.toString() ?? "",
      mainTab: (params["mainTab"] as string) ?? "overview",
      period: (params["period"] as string) ?? "",
    };
  },
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
});
